import { render } from "./ClientStatus.vue?vue&type=template&id=5cfb5a32&scoped=true"
import script from "./ClientStatus.vue?vue&type=script&lang=js"
export * from "./ClientStatus.vue?vue&type=script&lang=js"

import "./ClientStatus.vue?vue&type=style&index=0&id=5cfb5a32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cfb5a32"]])

export default __exports__